import { render } from "./UserSearch.vue?vue&type=template&id=3dc20878&scoped=true"
import script from "./UserSearch.vue?vue&type=script&lang=js"
export * from "./UserSearch.vue?vue&type=script&lang=js"

import "./UserSearch.vue?vue&type=style&index=0&id=3dc20878&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc20878"]])

export default __exports__